module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-08-bbdc8dd2a7e181ec2ba4307169088938.jpg";